module.exports = "<div class=\"tableModal\">\n    <div class=\"modal-header\">\n        <h3>{{title}}</h3>\n    </div>\n    <div>\n        <p ng-repeat=\"i in data\">{{i}}</p>\n    </div>\n</div>";


/*****************
 ** WEBPACK FOOTER
 ** ./src/pages/views/ioc_notifications/modal_desc.html
 ** module id = 729
 ** module chunks = 0
 **/